module.exports = __webpack_public_path__ + "l.no2.10538c05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/l.no2.jpg
// module id = xU81
// module chunks = 0